function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { asSingleStyleConfig } from '../../utils/theme';
var baseStyle = props => {
  var DEFAULT_SIZE = 1;
  var SIZES = {
    xs: DEFAULT_SIZE / 1.05,
    sm: DEFAULT_SIZE,
    md: DEFAULT_SIZE * 1.25,
    lg: DEFAULT_SIZE * 1.5,
    xl: DEFAULT_SIZE * 2
  };
  var getDimensions = () => {
    switch (props.size) {
      case 'xs':
        return {
          width: "".concat(SIZES.xs, "rem"),
          height: "".concat(SIZES.xs, "rem")
        };
      case 'sm':
        return {
          width: "".concat(SIZES.sm, "rem"),
          height: "".concat(SIZES.sm, "rem")
        };
      case 'md':
        return {
          width: "".concat(SIZES.md, "rem"),
          height: "".concat(SIZES.md, "rem")
        };
      case 'lg':
        return {
          width: "".concat(SIZES.lg, "rem"),
          height: "".concat(SIZES.lg, "rem")
        };
      case 'xl':
        return {
          width: "".concat(SIZES.xl, "rem"),
          height: "".concat(SIZES.xl, "rem")
        };
      default:
        return {
          width: "".concat(DEFAULT_SIZE, "rem"),
          height: "".concat(DEFAULT_SIZE, "rem")
        };
    }
  };
  return _objectSpread({}, getDimensions());
};
export default asSingleStyleConfig({
  baseStyle
});